const BASE = process.env.REACT_APP_API_URL || '/api';

function getToken() {
  return localStorage.getItem('bs_token');
}

async function request(path, options = {}) {
  const token = getToken();
  const res = await fetch(`${BASE}${path}`, {
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers
    },
    ...options
  });

  const data = await res.json();

  if (!res.ok) {
    if (res.status === 401 && data.expired) {
      localStorage.removeItem('bs_token');
      window.location.href = '/login';
    }
    throw new Error(data.error || 'Erreur serveur');
  }

  return data;
}

// ── AUTH ──
export const api = {
  register: (body) => request('/auth/register', { method: 'POST', body: JSON.stringify(body) }),
  login:    (body) => request('/auth/login',    { method: 'POST', body: JSON.stringify(body) }),
  me:       ()     => request('/auth/me'),

  // ── MODULES ──
  getModules:      ()      => request('/modules'),
  getModule:       (num)   => request(`/modules/${num}`),
  chatIA:          (num, body) => request(`/modules/${num}/chat`, { method: 'POST', body: JSON.stringify(body) }),
  validateModule:  (num, body) => request(`/modules/${num}/validate`, { method: 'POST', body: JSON.stringify(body) }),
  interetAbonnement: () => request('/modules/user/interet-abonnement', { method: 'POST' }),
  getDashboard:    ()      => request('/modules/user/dashboard'),

  // ── ADMIN ──
  adminGetUsers:    ()         => request('/admin/users'),
  adminGetUser:     (email)    => request(`/admin/users/${encodeURIComponent(email)}`),
  adminCreateUser:  (body)     => request('/admin/users', { method: 'POST', body: JSON.stringify(body) }),
  adminBlock:       (email, note) => request(`/admin/users/${encodeURIComponent(email)}/block`,   { method: 'PATCH', body: JSON.stringify({ note }) }),
  adminUnblock:     (email)    => request(`/admin/users/${encodeURIComponent(email)}/unblock`,  { method: 'PATCH', body: JSON.stringify({}) }),
  adminPremium:     (email)    => request(`/admin/users/${encodeURIComponent(email)}/premium`,  { method: 'PATCH', body: JSON.stringify({}) }),
  adminRevokePremium:(email)   => request(`/admin/users/${encodeURIComponent(email)}/revoke-premium`, { method: 'PATCH', body: JSON.stringify({}) }),
  adminDelete:      (email)    => request(`/admin/users/${encodeURIComponent(email)}`,          { method: 'DELETE' }),
  adminSuivi:       ()         => request('/admin/suivi'),
  adminCandidatures: ()        => request('/admin/candidatures'),
  adminCandidature:  (email, action) => request(`/admin/candidatures/${encodeURIComponent(email)}/${action}`, { method: 'POST' }),
  places:           ()         => request('/auth/places'),
  messages:         ()         => request('/messages'),
  messagesUnread:   (since)    => request(`/messages/unread${since ? '?since=' + encodeURIComponent(since) : ''}`),
  sendMessage:      (text)     => request('/messages', { method: 'POST', body: JSON.stringify({ text }) }),
  adminMessages:    ()         => request('/admin/messages'),
  adminThread:      (email)    => request(`/admin/messages/${encodeURIComponent(email)}`),
  adminReply:       (email, text) => request(`/admin/messages/${encodeURIComponent(email)}`, { method: 'POST', body: JSON.stringify({ text }) }),
  adminJournal:     ()         => request('/admin/journal'),
  adminMessage:     (email, message) => request(`/admin/users/${encodeURIComponent(email)}/message`, { method: 'POST', body: JSON.stringify({ message }) }),
  adminExtendDate:  (email, dateFinAcces) => request(`/admin/users/${encodeURIComponent(email)}/extend-date`, { method: 'PATCH', body: JSON.stringify({ dateFinAcces }) }),
};

